<template>
	<section ref="imagesSection"
			 class="flex-module container-fluid flexible-images">
		<div class="row">
			<div class="flexible-images-wrapper"
				 :class="containerWidthClasses">
				<div v-for="{ image } in item.images"
					 :key="image.id"
					 class="flexible-image-entry">
					<figure>
						<BaseEnlargeableImage :data="image"
											  :sizes="`${imageWidth}`"
											  :aspect-ratio="item?.force_aspect_ratio ? item?.aspect_ratio : null" />

						<figcaption v-if="image?.text"
									class="details"
									v-html="image?.text" />
					</figure>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
	sizes: {
		type: String,
		default: null,
	},
	trigger: {
		type: String,
		default: 'hover',
	}
})

const { gsap } = useGsap()

const imagesSectionRef = useTemplateRef('imagesSection')

const triggers = {}
let $q

const item = computed(() => props.data?.item)

const imageWidth = computed(() => {
	if (!item.value) return ''

	let size = 50

	if (item.value?.alignment === 'fullWidth') {
		const count = Math.max(1, item.value.images?.length || 1)
		const width = +(100 / count).toFixed(2)
		size = width > 100 ? 100 : width
	}

	return size ? `640px md:${size}vw 2xl:${size}vw` : ''
})

const containerWidthClasses = computed(() => {
	if (!item.value) return

	let string = ''

	if (item.value.alignment === 'fullWidth') { string = 'col-xs-12' }
	else {
		string = 'col-xs-12 col-sm-8 col-md-6 vertical'

		if (item.value.alignment === 'right') string = string + ' col-sm-offset-4 col-md-offset-6'
	}

	return string
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function animRevealImage() {
	triggers.tl = gsap.timeline({
		scrollTrigger: {
			id: 'revealImage',
			trigger: imagesSectionRef.value,
		}
	})

	triggers.tl.set($q('.reveal'), { autoAlpha: 1 })
	triggers.tl.from($q('.reveal'), {
		xPercent: -100,
		duration: 1.5,
		stagger: 0.25,
		ease: 'power4'
	}).from($q('.org-img'), {
		xPercent: 100,
		scale: 1.2,
		duration: 1.5,
		stagger: 0.25,
		ease: 'power4'
	}, '<')
}

function initFlexibleImages() {
	$q = gsap.utils.selector(imagesSectionRef.value)
	// animRevealImage()
}

onMounted(() => {
	useAnims(initFlexibleImages, triggers)
})
</script>

<style lang="scss" scoped>
.flexible-images-wrapper {
	display: flex;
	gap: calc($half-gutter-width * 2);

	.flexible-image-entry {
		width: 100%;

		img {
			width: 100% !important;
		}

		&:last-of-type {
			margin-right: 0;
		}
	}

	@include for-devices-below(md) {
		flex-direction: column;
	}

	&.vertical {
		flex-direction: column;

	}
}

.details {
	@include textDetails;
	color: var(--details-color, $black);
}
</style>
